import React, { FunctionComponent, useEffect, useState } from 'react';
import FileDownload from 'js-file-download';
import { useParams } from 'react-router-dom';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import DownloadIcon from '@mui/icons-material/Download';
import SaveIcon from '@mui/icons-material/Save';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import DeleteIcon from '@mui/icons-material/Delete';
import { IAlertProps } from '../../interface/IAlertProps';
import { getDefaultAlertProps } from '../../utils/utils';
import { IApiResult } from '../../interface/IApiResult';
import {
  API_STATUS_PROBLEM,
  DOWNLOAD_FILE_NUM,
  POOL_TYPE,
} from '../../constant/constants';
import { AlertSeverityEnum } from '../../enum/AlertSeverityEnum';
import { MyAlert } from '../UI/MyAlert';
import { ContentDto } from '../../dto/ContentDto';
import { apiGetPool } from '../../service/apiGetPool';
import { apiDeleteContent } from '../../service/apiDeleteContent';
import { AddFile } from '../add-file/AddFile';
import { TextDto } from '../../dto/TextDto';
import { apiSavePool } from '../../service/apiSavePool';
import { MyTextFiled } from '../UI/MyTextField';
import { BackDropDiv } from '../backdrop/BackDropDiv';

interface Props {
  open: boolean;
  isEdit?: boolean;
  onClose: () => void;
  dto?: ContentDto;
}

export const DialogPool: FunctionComponent<Props> = ({
  open,
  dto,
  isEdit,
  onClose,
}) => {
  const [alertProps, setAlertProps] = useState<IAlertProps>(
    getDefaultAlertProps()
  );
  const [pool, setPool] = useState('');

  const handleClose = () => {
    setPool('');
    onClose();
  };
  const { section } = useParams();
  const [backDrop, setBackDrop] = useState(false);
  const getPool = async (route: string, name: string, download?: number) => {
    setBackDrop(true);
    const apiResult: IApiResult = await apiGetPool(route, name, download);
    if (apiResult.isSuccess) {
      if (download === undefined) {
        setPool(apiResult.data);
      } else {
        FileDownload(
          apiResult.data,
          `${route}_латинские_карточки_${dto?.key}_${dto?.title}_##_${name}` ??
            ''
        );
      }
    } else if (apiResult.status !== 404) {
      setAlertProps({
        message: API_STATUS_PROBLEM,
        severity: AlertSeverityEnum.error,
      });
    }
    setBackDrop(false);
  };

  const saveText = async (
    route: string,
    name: string,
    key: string,
    title: string
  ) => {
    const textDto: TextDto = {
      text: pool,
    };
    const apiResult: IApiResult = await apiSavePool(
      route,
      name,
      key,
      title,
      textDto
    );
    if (apiResult.isSuccess) {
      setAlertProps({
        message: 'Данные записаны',
        severity: AlertSeverityEnum.info,
      });
      getPool(section ?? '', dto?.pool ?? '');
    } else {
      setAlertProps({
        message: API_STATUS_PROBLEM,
        severity: AlertSeverityEnum.error,
      });
    }
  };

  const deleteContent = async (route: string, type: number, key: string) => {
    const apiResult: IApiResult = await apiDeleteContent(route, type, key);
    if (apiResult.isSuccess) {
      setPool('');
    } else {
      setAlertProps({
        message: API_STATUS_PROBLEM,
        severity: AlertSeverityEnum.error,
      });
    }
  };

  useEffect(() => {
    if (open) {
      getPool(section ?? '', dto?.pool ?? '');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  return (
    <div>
      <Dialog
        open={open}
        fullWidth
        maxWidth="xl"
        style={{ userSelect: 'none' }}
        PaperProps={{
          sx: { backgroundColor: '#e7ebee', width: '100%', height: '100%' },
        }}
      >
        <BackDropDiv open={backDrop} />
        <MyAlert
          message={alertProps.message}
          severity={alertProps.severity}
          onClose={() => setAlertProps({ ...alertProps, message: '' })}
        />
        <DialogTitle>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <Typography
              style={{
                fontFamily: 'sans-serif',
                fontStyle: 'normal',
                fontWeight: 500,
                fontSize: '24px',
                color: '#000000',
                letterSpacing: 1,
              }}
              component="text"
            >
              {`Латинские карточки - ${dto?.key} ${dto?.title}`}
            </Typography>
            <Stack direction="row" spacing={1}>
              {!isEdit && (
                <Stack direction="row" spacing={1}>
                  <IconButton
                    title="Скачать"
                    size="small"
                    onClick={() =>
                      getPool(section ?? '', dto?.pool ?? '', DOWNLOAD_FILE_NUM)
                    }
                  >
                    <DownloadIcon fontSize="large" sx={{ color: '#9c27b0' }} />
                  </IconButton>
                </Stack>
              )}
              {isEdit && (
                <Stack direction="row" spacing={1}>
                  <IconButton
                    title="Сохранить"
                    size="small"
                    onClick={() =>
                      saveText(
                        section ?? '',
                        dto?.pool ?? '',
                        dto?.key ?? '',
                        dto?.title ?? ''
                      )
                    }
                  >
                    <SaveIcon fontSize="large" sx={{ color: '#2196f3' }} />
                  </IconButton>
                  <AddFile
                    name="fileToUpload"
                    icon={
                      <FileUploadIcon
                        fontSize="large"
                        sx={{ color: '#9c27b0' }}
                      />
                    }
                    typeContent={POOL_TYPE}
                    dto={dto}
                  />
                  <IconButton
                    title="Удалить"
                    size="small"
                    onClick={() =>
                      deleteContent(
                        section ?? '',
                        POOL_TYPE,
                        dto?.key ?? '-11111'
                      )
                    }
                  >
                    <DeleteIcon fontSize="large" sx={{ color: 'red' }} />
                  </IconButton>
                </Stack>
              )}
              <IconButton title="Закрыть" size="small" onClick={handleClose}>
                <CloseIcon fontSize="large" sx={{ color: '#000000' }} />
              </IconButton>
            </Stack>
          </Stack>
        </DialogTitle>
        <DialogContent>
          <Stack>
            {!isEdit && (
              <Typography
                sx={{ wordBreak: 'break-word' }}
                style={{
                  fontFamily: 'sans-serif',
                  fontStyle: 'normal',
                  fontWeight: 500,
                  fontSize: '16px',
                  color: '#000000',
                  letterSpacing: 1,
                  display: 'inline-block',
                  whiteSpace: 'pre-line',
                }}
                component="text"
              >
                {`${pool}`}
              </Typography>
            )}
            {isEdit && (
              <MyTextFiled
                value={pool}
                multiLine
                onChange={(e) => setPool(e.target.value)}
                size="small"
                label=""
              />
            )}
          </Stack>
        </DialogContent>
      </Dialog>
    </div>
  );
};

DialogPool.defaultProps = {
  isEdit: false,
  dto: undefined,
};
